import { render, staticRenderFns } from "./ApplyWorkloadConfigurationDialog.vue?vue&type=template&id=6b3e9961"
import script from "./ApplyWorkloadConfigurationDialog.vue?vue&type=script&lang=js"
export * from "./ApplyWorkloadConfigurationDialog.vue?vue&type=script&lang=js"
import style0 from "./ApplyWorkloadConfigurationDialog.vue?vue&type=style&index=0&id=6b3e9961&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports